import { DependencyList, useEffect, useRef } from 'react'

/**
 * Run useEffect but not on initial render
 *
 * We use a ref here as it's a means of tracking / changing mutable variables in React
 * without triggering a re-render of the React tree
 *
 * First run didMount is false, after rendering we immediately make it true (but prevent it from re-rendering)
 */
const useDidMountEffect = (
  effect: () => void,
  dependencies: DependencyList
) => {
  const didMount = useRef(false)

  useEffect(() => {
    if (didMount.current) effect()
    else didMount.current = true
    // TODO #6362 - Fix ESLint - hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies)
}

export default useDidMountEffect
